/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
import { SessionProvider } from '../contexts/session_context'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/styles.css'

function MyApp({ Component, pageProps }) {
    return (
        <SessionProvider>
          <div className="site-container">
            <Component {...pageProps} />
          </div>
        </SessionProvider>
    )
}


export default MyApp
